import gql from 'graphql-tag';
import gqlClient from 'js/graphql/client/gqlClient';
import logoutUser from 'js/graphql/logout';

export const queryCampaign = async id => {
    try {
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }
        const result = await gqlClient.client.query({
            query: gql`
                query Campaign($id: ID!) {
                    campaign(id: $id) {
                        id
                        estimatedAdBudget
                        campaignKpi {
                            categoryId
                            categoryName
                            kpiBenchmarkValue
                            subCategory {
                                subCategoryId
                                subCategoryName
                                kpiValueKind
                            }
                        }
                        # Products In Content
                        products {
                            edges {
                                node {
                                    id
                                    value
                                    availability
                                    isRequired
                                }
                            }
                        }

                        # Audience Location
                        audienceGeographies {
                            id
                            createdAt
                            updatedAt
                            geographyComponent {
                                id
                                kind

                                ... on GeographyComponentContinent {
                                    continent
                                }

                                ... on GeographyComponentCountry {
                                    countryCode
                                    countryName
                                }

                                ... on GeographyComponentCity {
                                    cityName
                                    countryCode
                                    regionCode
                                }

                                ... on GeographyComponentRegion {
                                    regionCode
                                    countryCode
                                    regionName
                                }

                                ... on GeographyComponentGooglePlaceId {
                                    description
                                    googlePlaceId
                                }
                            }
                        }

                        # Audience Interests
                        audienceInterests {
                            createdAt
                            updatedAt
                            interest
                            isCustomInterest
                        }

                        # Audience Age Range
                        audienceAgeRanges {
                            createdAt
                            updatedAt
                            minAgeYearsInclusive
                            maxAgeYearsInclusive
                            ageRangeDescription
                        }

                        # Audience Gender
                        audienceGenders {
                            audienceGenderId
                            audienceGender
                        }

                        # Followers
                        creatorTargetFollowers {
                            minFollowers
                            maxFollowers
                        }

                        # Audience Languages
                        audienceLanguages {
                            audienceLanguage {
                                description
                                code
                            }
                        }

                        # Deliverable Quantity
                        productions {
                            edges {
                                node {
                                    id
                                    conquestBrandNames {
                                        edges {
                                            node {
                                                id
                                                conquestKind
                                                name
                                            }
                                        }
                                    }
                                    finalDeliverable {
                                        id
                                        kind
                                    }
                                    tree {
                                        productionId
                                        nodes {
                                            type
                                            id
                                            parentId
                                            rootId
                                            depth
                                            type
                                            ... on ProductionNodeAssignee {
                                                variant
                                                directions {
                                                    directionTreeId
                                                    productionId
                                                    productionNodeId
                                                    directionTreeId
                                                    nodes {
                                                        id
                                                        parentId
                                                        rootId
                                                        depth
                                                        ... on DirectionRule {
                                                            subjectInstanceId
                                                            subject
                                                            topic
                                                            operator
                                                            descriptor
                                                            uiRef
                                                        }
                                                        ... on DirectionConnective {
                                                            kind
                                                        }
                                                    }
                                                }
                                            }
                                            ... on ProductionNodeDeliverable {
                                                variant
                                                directions {
                                                    directionTreeId
                                                    productionId
                                                    productionNodeId
                                                    directionTreeId
                                                    nodes {
                                                        id
                                                        parentId
                                                        rootId
                                                        depth
                                                        ... on DirectionRule {
                                                            subjectInstanceId
                                                            subject
                                                            topic
                                                            operator
                                                            descriptor
                                                            uiRef
                                                        }
                                                        ... on DirectionConnective {
                                                            kind
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        # Deliverable Kind
                        deliverableDescriptors {
                            edges {
                                node {
                                    id
                                    kind
                                    contentSpecs {
                                        edges {
                                            node {
                                                id
                                                createdAt
                                                updatedAt
                                                kind
                                                ... on VideoSpec {
                                                    productionStyleOptions
                                                }
                                                aspectRatioOptions
                                            }
                                        }
                                    }

                                    ... on SocialChannelDeliverableDescriptor {
                                        id
                                        kind
                                        socialPostKind
                                        socialPlatform
                                    }

                                    ... on ContentDeliverableDescriptor {
                                        id
                                        kind
                                        intendedForDistributionChannels {
                                            kind
                                            socialPostKinds
                                            socialPosts {
                                                platform
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        # guidelines
                        guidelines {
                            edges {
                                node {
                                    id
                                    createdAt
                                    updatedAt
                                    must
                                    description
                                    subject
                                    isActive
                                    position
                                }
                            }
                        }

                        # hashtags
                        requiredHashtags {
                            id
                            hashtag
                        }

                        # handles
                        requiredHandles {
                            id
                            handle
                        }
                    }
                }
            `,
            variables: {id}
        });

        const campaignData = result.data.campaign;
        if (campaignData) {
            return campaignData;
        }
    } catch (error) {
        if (error.message.includes('401')) {
            return logoutUser();
        }
        throw error;
    }
    return {};
};



// WEBPACK FOOTER //
// ./graphql/queries/queryCampaign.js